import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { OrganizationsList } from '@openx/types/organization';
import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.palette.primary.main};
  display: inline-block;

  &:after {
    content: '/';
    display: inline-block;
    margin: ${({ theme }) => theme.spacing(0, 1)};
  }

  &:last-of-type {
    &:after {
      content: none;
    }
  }
`;

export type AccountHierarchyProps = {
  accountHierarchy: Pick<OrganizationsList, 'id' | 'name'>[];
};

export const AccountHierarchy = ({ accountHierarchy }: AccountHierarchyProps) => {
  const { t } = useTranslation();
  const onClick = (event: MouseEvent<HTMLElement>) => event.stopPropagation();

  return (
    <Typography variant="body2" data-test="account-hierarchy" component="div" color="textSecondary">
      <Typography variant="body2" component="span" color="textPrimary" sx={{ mr: 1 }}>
        {t('Account Hierarchy')}:
      </Typography>

      {accountHierarchy.map(account => (
        <StyledLink onClick={onClick} to={`/organizations/${account.id}/details`} key={account.id}>
          {account.name}
        </StyledLink>
      ))}
    </Typography>
  );
};
